import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Bannerfrom from "../../components/bannerfrom";
import {Link} from 'gatsby';

function Banner(props) {
    return (
        <div className="services_location_banner">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
                        <div className="banenr_content">
                            <div className="example" data-text="Mobile">
                                <h1>Top-Notch <span>Mobile App</span> Development Company</h1>
                            </div>
                            <p className="main_para">TekRevol abides by a code of excellence. Our team raises the bar in app development standards, ensuring each project is a testament to quality, innovation, and user satisfaction.</p>
                            <Link to="https://www.tekrevol.com/contact"
                                  className="border_btn dark_btn" aria-label="TekRevol Contact"> Let’s Connect!</Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
                        <Bannerfrom/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;